// Chevron fill: relies on the `color` prop when given, otherwise falls back to
// the `.svg-icon` class colour. The catch — `.MuiInputBase-root > .material-icons`
// in theme.css sets `fill: ... !important` on the icon, which a plain attribute
// or React style object can't beat. So when `color` is set we pin it on the path
// via a ref with `setProperty(..., "important")`, the only way to emit !important.
const DropDownArrowIcon = ({ className, style, color }) => {
  const pinFill = (node) => {
    if (!node) return;
    if (color) node.style.setProperty("fill", color, "important");
    else node.style.removeProperty("fill");
  };
  return (
    <svg
      className={className}
      style={style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        ref={pinFill}
        d="M4.17 4.818a1.035 1.035 0 0 0-1.518 1.408l4.615 4.982a1 1 0 0 0 1.467 0l4.615-4.982a1.035 1.035 0 0 0-1.518-1.408L8 8.945 4.17 4.818z"
        className={color ? undefined : "svg-icon"}
      />
    </svg>
  );
};

export default DropDownArrowIcon;
